module.exports = __webpack_public_path__ + "img/Advancing_STEM_Education_Through_Our_Rising_Stars.87483653.jpg";